module.exports = __webpack_public_path__ + "static/media/nature.8651d559.jpg";